module.exports = require("@wallaby-ui/document");